import React from 'react';
import ReactDOM from 'react-dom';
import HandleErrorMessage from '.';

const ErrorPortal: React.FC = () => {
    return ReactDOM.createPortal(<HandleErrorMessage />, document.body);
};

export default ErrorPortal;
